<template>
    <div class="centercontainer">
        <div class="center">
            <h2>{{ $t('common.pageNotFound') }}</h2>
        </div>
    </div>
</template>
